import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PublicOnboarding from './pages/PublicOnboarding';
import Login from './pages/Login';
import Layout from './pages/Layout';
import Dashboard from './pages/Dashboard';
import Organizations from './pages/Organizations';
import OrganizationDetails_i2 from './pages/OrganizationDetails_i2';
import OnboardingDetails from './pages/OnboardingDetails';
import CustomerDetails from './pages/CustomerDetails';
import IntegrationDetails from './pages/IntegrationDetails';
import Administrators from './pages/Administrators';
import Settings from './pages/Settings';
import WhatsAppManager from './pages/WhatsAppManager';
import CustomerCategories from './pages/CustomerCategories';
import CategoryDetails from './pages/CategoryDetails';
import CreateCategory from './pages/CreateCategory';
import APArchetypes from './pages/APArchetypes';
import CreateAPArchetype from './pages/CreateAPArchetype';
import APArchetypeDetails from './pages/APArchetypeDetails';
import GovernanceOverlays from './pages/GovernanceOverlays';
import CreateGovernanceOverlay from './pages/CreateGovernanceOverlay';
import GovernanceOverlayDetails from './pages/GovernanceOverlayDetails';
import PrivateRoute from './components/PrivateRoute';
import { UserProvider } from './context/UserContext';
import './App.css';

function App() {
  return (
    <UserProvider>
      <Router>
        <div className="App">
        <Routes>
          <Route path="/public/:token" element={<PublicOnboarding />} />
          <Route path="/org/:organizationSlug" element={<PublicOnboarding />} />
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/organizations"
              element={
                <PrivateRoute>
                  <Layout>
                    <Organizations />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/organizations/:organizationId"
              element={
                <PrivateRoute>
                  <Layout>
                    <OrganizationDetails_i2 />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/organizations/:organizationId/onboarding"
              element={
                <PrivateRoute>
                  <OnboardingDetails />
                </PrivateRoute>
              }
            />
            <Route
              path="/organizations/:organizationId/customers/:customerId"
              element={
                <PrivateRoute>
                  <Layout>
                    <CustomerDetails />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/integration/:integrationId"
              element={
                <PrivateRoute>
                  <Layout>
                    <IntegrationDetails />
                  </Layout>
                </PrivateRoute>
                }
              />
            <Route
              path="/administrators"
              element={
                <PrivateRoute>
                  <Layout>
                    <Administrators />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <PrivateRoute>
                  <Layout>
                    <Settings />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/whatsapp-manager"
              element={
                <PrivateRoute>
                  <Layout>
                    <WhatsAppManager />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/customer-categories"
              element={
                <PrivateRoute>
                  <Layout>
                    <CustomerCategories />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/customer-categories/create"
              element={
                <PrivateRoute>
                  <Layout>
                    <CreateCategory />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/customer-categories/:id"
              element={
                <PrivateRoute>
                  <Layout>
                    <CategoryDetails />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/ap-archetypes"
              element={
                <PrivateRoute>
                  <Layout>
                    <APArchetypes />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/ap-archetypes/create"
              element={
                <PrivateRoute>
                  <Layout>
                    <CreateAPArchetype />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/ap-archetypes/:id"
              element={
                <PrivateRoute>
                  <Layout>
                    <APArchetypeDetails />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/governance-overlays"
              element={
                <PrivateRoute>
                  <Layout>
                    <GovernanceOverlays />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/governance-overlays/create"
              element={
                <PrivateRoute>
                  <Layout>
                    <CreateGovernanceOverlay />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/governance-overlays/:id"
              element={
                <PrivateRoute>
                  <Layout>
                    <GovernanceOverlayDetails />
                  </Layout>
                </PrivateRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </UserProvider>
  );
}

export default App;
